<div class="container">
    <h1 class="title">Présentation du Circuit</h1>
    <p>
        L’association CDFL a pour objectif de promouvoir le Legacy et d’organiser le circuit compétitif permettant l’accès à la Coupe de France de Legacy.
    </p>
    <p>
        Tout d’abord, la Finale de la Coupe de France est un tournoi annuel visant à réunir les meilleurs joueurs de Legacy de France.
        <br>
        En 2026, La finale se déroulera à Caen et sera organisé par le <a href="https://www.facebook.com/clubmagicnormand" target="_blank">Club Magic Normand</a> !
        <br>
        Pour pouvoir y participer, il faut être qualifié ! Il y a trois façons de se qualifier : 
        <ul>
            <li>Les Main Qualifier Legacy</li>
            <li>Les Opens Qualifier</li>
            <li>Les Anciens Gagnants </li>
        </ul>
    <h1 class="subtitle">Les Main Qualifier Legacy</h1>
    <p>
        Les Main Qualifier Legacy sont des tournois  d'envergure réalisés en collaboration avec des organisateurs locaux, ils ont pour vocation de permettre à chaque personne de métropole d’avoir un tournoi majeur à proximité. Pour 2025, les Main Qualifier prévu sont :
        <br>
        Chaque Main Qualifier Legacy permet de qualifier 1 personne tous les 8 inscrits. Exemples: sur un tournoi à 64 joueurs, les joueurs du top 8 seront qualifiés ; pour un tournoi à 128 joueurs, le  top 16 sera qualifiés.
        <ul>
            <li>Caen (date non défini) - organisé par le <a href="https://www.facebook.com/clubmagicnormand" target="_blank">Club Magic Normand</a></li>
            <li>Lyon (16-17 Janvier) - organisé par <a href="https://www.facebook.com/mtgones" target="_blank">MTGGONES</a></li>
            <li>Toulouse (8-10 Mai) - organisé par le <a href="https://www.facebook.com/MagicClubBessieres" target="_blank">MCB</a>
            <li>Ravel (date non défini) - organisé par <a href="https://www.facebook.com/MagicBougnat" target="_blank">Magic Bougnat</a></li>
        </ul>
    <p>
        Réveillez la ferveur du Legacy dans votre région !
        <br>
        Vous rêvez de réunir les meilleurs joueurs de Legacy autour de vous ? Cette année, c'est l'occasion idéale de passer à l'action ! 
        <br>
        Devenez l'hôte d'un Main Qualifier Legacy et organisez le plus éblouissant tournoi Legacy que votre région n'ait jamais vu !
        <br>
        L'atout majeur ? Une qualification garantie pour 1 joueur sur 8 inscrits, boostant l'engouement et la compétition !
        <br>
        Le défi ? Présenter un projet qui électrise la communauté des joueurs de Legacy. Nous sommes convaincus que vous avez les idées pour y parvenir !
        Prêt à lancer votre projet ? Ne vous inquiétez pas pour les détails : l'équipe CDF sera à vos côtés tout au long du processus.
        Contactez Luka sur notre <a href="https://discord.gg/UUqRtweMCp" target="_blank">discord</a>.
    </p>
    <h1 class="subtitle">Les Open Qualifier</h1>
    <p>
        Les Open Qualifier Legacy tournois sont des tournois que n'importe quel organisateur peut organiser.
        <br>
        Ces tournois ont pour but de redynamiser les communautés locales ainsi tous tournois organisé par une association, organisation ou boutique peut être considéré comme un Open Qualifier, à condition que l'organisateur respecte le point suivant :
        <br>
        Avoir annoncer le tournoi en amont comme Open Qualifier Legacy (avec notre logo par exemple :p)
    <p>
        Chaque tournoi annoncé Open Qualifier qualifie un joueur tous les 14 participants présents.
        <br>
        Chaque open qualifie 1 joueurs à partir de 14 joueurs présent lors du tournoi.
        <br>
        Chaque open qualifie 2 joueurs à partir de 28 joueurs présent lors du tournoi.
        <br>
        Chaque open qualifie 3 joueurs à partir de 42 joueurs présent lors du tournoi.
        <br>
        Chaque open qualifie 4 joueurs à partir de 56 joueurs présent lors du tournoi.
        <br>
        Et ainsi de suite par intervalle de 14 joueurs.
    <p>
        Après l'événement, l’organisateur communique les résultats du tournoi aux organisateurs de la CDFL via <b>coupedefrancelegacy@gmail.com</b>
    <p>
        Pour limiter que certaines régions très dynamiques ne qualifient trop de ces joueurs, les Opens Qualifier sont limités à 1 par mois par association, organisation ou boutique avec une certaine souplesse, au besoin les organisateurs peuvent contacter l’asso CDFL sur <a href="https://discord.gg/UUqRtweMCp" target="_blank">discord</a>.
        <br>
        Cela signifie que si votre région est assez dynamique, vos tournois mensuels deviennent tous des Opens Qualifier Legacy. Nous invitons les organisateurs de tournois hebdomadaires à fixer un tournoi par mois comme Open Qualifier Legacy (le premier du mois par exemple).
    <h1 class="subtitle">Les Anciens Gagnants</h1>
    <p>
        L’ensemble des précédents gagnants de la CDFL sont toujours qualifié à la finale
</div>